<template>
  <div class="calendar">
    <div class="calendar__header">
      <button class="prev-btn" @click="handlePrevMonth"></button>
      <span class="calendar__header_date"
        >{{ year }}<span class="text">年 </span>{{ month
        }}<span class="text">月</span></span
      >
      <button
        class="next-btn"
        @click="handleNextMonth"
        :disabled="isNext"
      ></button>
    </div>
    <div class="calendar__body">
      <div v-for="week in weekArray" :key="week">
        {{ week }}
      </div>
      <div class="calendar__cell" v-for="date in monthDays" :key="date">
        <button
          v-if="date"
          class="calendar__day"
          :class="handleDayClass(date)"
          @click="handlemMoveDate(year, month, date)"
          type="button"
        >
          {{ handleFormattedDate(date) }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { defineObject } from '@/lib/define/use-define'
import moment from 'moment'

export default {
  data() {
    return {
      isNext: false,
      year: null,
      month: null,
      day: null,
      currentYear: null,
      currentMonth: null,
      currentDay: null,
      monthDays: null,
      weekArray: null,
    }
  },
  props: {
    selectYear: {
      type: Number,
      required: true,
    },
    selectMonth: {
      type: Number,
      required: true,
    },
    selectDay: {
      type: Number,
      required: true,
    },
  },
  created() {
    const cuurentDate = new Date(
      this.selectYear,
      this.selectMonth - 1,
      this.selectDay
    )
    this.monthDays = this.handleGetMonthDays(
      cuurentDate,
      this.selectYear,
      this.selectMonth - 1
    )
    this.weekArray = defineObject.FORMULA_WEEK_ARRAY
    this.currentYear = cuurentDate.getFullYear()
    this.currentMonth = cuurentDate.getMonth() + 1
    this.currentDay = cuurentDate.getDate()

    this.handleIsNextCheck()
  },
  methods: {
    handleGetDaysNumberInMonth(date) {
      const year = date.getFullYear()
      const month = date.getMonth()
      this.year = date.getFullYear()
      this.month = date.getMonth() + 1

      // その月の末日が取得できる
      return 33 - new Date(year, month, 33).getDate()
    },
    handleGetNormalizedWeekDayNumber(date) {
      const number = Number(date.getDay())

      return number === 0 ? 0 : number
    },
    handleFormatDateToYyyyMmDdString(date) {
      return date.toISOString().slice(0, 10)
    },
    handlefFormatDateToDdString(date) {
      return String(date.getDate())
    },
    handleFormattedDate(dateString) {
      return dateString
        ? this.handlefFormatDateToDdString(new Date(dateString))
        : ''
    },
    handleGetMonthDays(date, year, month) {
      const cuurentYear = date.getFullYear() // 年
      const cuurentMonth = date.getMonth() // 月
      const firstDayInMonth = new Date(year, month, 1)
      const lastDaysNumber = this.handleGetDaysNumberInMonth(
        date
        // this.selectYear,
        // this.selectMonth
      )
      const emptyCellsNumber =
        this.handleGetNormalizedWeekDayNumber(firstDayInMonth)
      const monthDays = this.handleGetNormalizedWeekDayNumber(date)
        ? new Array(emptyCellsNumber)
        : []
      for (let i = 1; i <= lastDaysNumber; i++) {
        monthDays.push(
          this.handleFormatDateToYyyyMmDdString(
            new Date(cuurentYear, cuurentMonth, i + 1)
          )
        )
      }
      return monthDays
    },
    handleIsNextCheck() {
      const cuurentDate = new Date(this.year, this.month)

      const hiddenDate = moment(new Date(), 'YYYY-MM').add(12, 'months')

      const nextYear = cuurentDate.getFullYear()
      const nextMonth = cuurentDate.getMonth() + 1

      if (moment(`${nextYear}-${nextMonth}`, 'YYYY-MM').isAfter(hiddenDate)) {
        // ボタン無効化
        this.isNext = true
      } else {
        this.isNext = false
      }
    },
    handleNextMonth() {
      const cuurentDate = new Date(this.year, this.month)
      this.monthDays = this.handleGetMonthDays(
        cuurentDate,
        this.year,
        this.month
      )

      this.handleIsNextCheck()
    },
    handlePrevMonth() {
      const cuurentDate = new Date(this.year, this.month - 2)
      this.monthDays = this.handleGetMonthDays(
        cuurentDate,
        this.year,
        this.month - 2
      )
      this.handleIsNextCheck()
    },
    handleDayClass(date) {
      if (
        this.currentYear === this.year &&
        this.currentMonth === this.month &&
        this.currentDay === Number(this.handleFormattedDate(date))
      ) {
        return 'current_date'
      }
    },
    handlemMoveDate(year, month, date) {
      const day = Number(this.handleFormattedDate(date))
      this.$emit('moveDayScadule', year, month, day)
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  appearance: none;
}
.current_date {
  border-radius: 50px;
  background: $main_color !important;
  color: #ffffff !important;
}

.calendar {
  width: 210px;
  .calendar__header {
    width: 210px;
    text-align: center;
    position: relative;
    top: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    .calendar__header_date {
      display: inline-block;
      font-size: 18px;
      font-weight: bold;
      color: $base_text_color;
      .text {
        font-size: 14px;
      }
    }
    .prev-btn {
      outline: none;
      border: none;
      display: flex;
      margin-right: 16px;
      &:disabled {
        opacity: 0.5;
      }
      &::after {
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 9px 15.6px 9px 0;
        border-color: transparent $base_text_color transparent transparent;
      }
    }
    .next-btn {
      outline: none;
      border: none;
      display: flex;
      margin-left: 16px;
      &:disabled {
        opacity: 0.5;
      }
      &::after {
        content: '';
        display: inline-block;
        width: 0;
        height: 0;
        border-style: solid;
        border-width: 9px 0 9px 15.6px;
        border-color: transparent transparent transparent $base_text_color;
      }
    }
  }
  .calendar__body {
    margin-top: 26px;
    display: grid;
    width: 100%;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(5, 24px);
    row-gap: 5px;
    text-align: center;
    .calendar__cell {
      font-weight: 500;
      font-size: 14px;
      line-height: 18px;

      .calendar__day {
        width: 30px;
        height: 30px;
        color: $base_text_color;
        background: transparent;
        border: none;
        outline: none;
        padding: 0 !important;
        &_active {
          position: relative;
          color: white;
        }
      }
    }
  }
}
</style>
